import { useAtomValue } from 'jotai';

import { IncomeDataT } from '@consumer-frontend/nc-utils';
import { Container } from '@consumer-frontend/shared-ui';

import { useApplyRouting } from '../../routing';
import { incomeDataAtom } from '../../store';
import { NcIncomeSourceForm } from '../NcIncomeSourceForm';
import { NcProgressBar } from '../NcProgressBar';

// eslint-disable-next-line import/order
import '@consumer-bootstrap/brands/netcredit/apply/income_source.scss';
import '@consumer-bootstrap/netcredit.scss';

export const NcIncomeSourcePage: React.FC = () => {
  const { handleContinue, progress } = useApplyRouting();
  const incomeData = useAtomValue(incomeDataAtom);

  const onSubmit = async (data: IncomeDataT) => {
    await handleContinue({}, data);
  };

  return (
    <Container className="nc-income-source-page" hasBoxShadow>
      <NcProgressBar progress={progress} />

      <h1 className="h3">Income Source</h1>

      <NcIncomeSourceForm
        incomeData={incomeData}
        onSubmitComplete={onSubmit}
      />
    </Container>
  );
};
